import { createUseStyles, useTheme } from 'react-jss'

const useStyles = createUseStyles({
  fieldItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minWidth: 0,
  },
  fieldLabel: {
    fontSize: 12,
    fontWeight: 500,
    color: ({ theme }) => theme.textGrayColor,
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
  },
  fieldValue: {
    fontSize: 14,
    fontWeight: 500,
    color: ({ theme }) => theme.textColor,
    lineHeight: '22px',
    // Emails, provider names and serial numbers have no break opportunities and
    // would otherwise be clipped by the grid column rather than wrapping.
    overflowWrap: 'anywhere',
  },
  fieldValueEmpty: {
    color: '#d9d9d9',
    fontStyle: 'italic',
    fontWeight: 400,
  },
  fieldValueLink: {
    color: ({ theme }) => theme.brandPrimary,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
})

export default function FieldItem({ label, value, link }) {
  const theme = useTheme()
  const classes = useStyles({ theme })
  const displayValue = value || null

  return (
    <div className={classes.fieldItem}>
      <span className={classes.fieldLabel}>{label}</span>
      {link && displayValue ? (
        <a href={link} className={`${classes.fieldValue} ${classes.fieldValueLink}`}>
          {displayValue}
        </a>
      ) : (
        <span className={`${classes.fieldValue} ${!displayValue ? classes.fieldValueEmpty : ''}`}>
          {displayValue || '\u2014'}
        </span>
      )}
    </div>
  )
}
